import React from 'react';

import { RiskDashboardServerCustomersApiProvider } from './customer/risk-dashboard-server-customer-api-provider';
import { RiskDashboardServerDefaultApiProvider } from './default/risk-dashboard-server-default-api-provider';

export const RiskDashboardServerApiProvider = ({
  children,
}: React.PropsWithChildren) => {
  return (
    <RiskDashboardServerDefaultApiProvider>
      <RiskDashboardServerCustomersApiProvider>
        {children}
      </RiskDashboardServerCustomersApiProvider>
    </RiskDashboardServerDefaultApiProvider>
  );
};
